import { BlogsManager } from './blogs-manager';
import { BlogsManagerProvider } from './blogs-manager.provider';

export const FeatureBlogsManager = () => {
   return (
      <BlogsManagerProvider>
         <BlogsManager></BlogsManager>
      </BlogsManagerProvider>
   );
};